import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { Header, Button, Modal } from 'semantic-ui-react';
import styles from './DriverKillQuestions.module.scss';

const DriverKillQuestions = ({ onContinue, onCancel }) => {
	const [showContactAgent, setShowContactAgent] = useState(false);
	return (
		<div>
			<Modal open={showContactAgent} onClose={() => setShowContactAgent(false)} size='tiny'>
				<Modal.Header>Contact Your Agent</Modal.Header>
				<Modal.Content>Please contact your agent for further assistance.</Modal.Content>
				<Modal.Actions>
					<Button onClick={() => setShowContactAgent(false)} primary>Close</Button>
				</Modal.Actions>
			</Modal>
			<div>
				<Header>Do any of the following apply?</Header>
				<div className={styles.questionContainer}>
					<div>
						<ul>
							<li>Financial responsibility filing</li>
							<li>Has this driver had more than 1 accident or more than 1 violation in the last 3 years?</li>
							<li>Disregarding a police officer</li>
							<li>Driving under the influence of alcohol or drugs</li>
							<li>Driving with a suspended, invalid or revoked driver's license</li>
							<li>Failure to report an accident</li>
							<li>Fleeing or eluding a police officer</li>
							<li>Hit and run</li>
							<li>Leaving the scene of an accident</li>
							<li>Racing, participating in racing, dragging</li>
							<li>Reckless driving</li>
							<li>Speeding 26 mph or more over the legal limit</li>
							<li>Vehicular homicide or assualt with a motor vehicle</li>
							<li>Is the driver 80 years of age or older?</li>
							<li>Does the driver have physical/mental impairment?</li>
						</ul>
					</div>
				</div>
			</div>
			<div className={styles.buttons}>
				<Button id="yesBtn" primary onClick={() => setShowContactAgent(true)}>
					Yes
				</Button>
				<Button id="noBtn" primary onClick={onContinue}>
					No
				</Button>
				<Button id="cancelBtn" primary onClick={onCancel}>
					Cancel
				</Button>
			</div>
		</div>
	);
};

DriverKillQuestions.propTypes = {
	onContinue: PropTypes.func.isRequired,
	onCancel: PropTypes.func.isRequired
};

export default DriverKillQuestions;
